import { useMemo } from 'react';
import type { Options } from 'react-select';
import { type DropdownOption, transformCustomer } from '../utils/optionTransformers';
import type { Customer } from './fragments/gql/Customer';
import { useAllCustomers } from './useAllCustomers';

export const useAllCustomersAsOptions = (options?: {
  includeClosedCustomers?: boolean;
}): Options<DropdownOption<Customer>> => {
  const customers = useAllCustomers(options);

  return useMemo(() => customers.map(transformCustomer), [customers]);
};
